import AccessLog from './accessLog';
import SecurityEvents from './securityEvents';
import SecurityEventDestination from './securityEventDestination';
import configInternalTasks from './configInternalTasks';
import connectionGroup from './connectionGroup';
import connections from './connections';
import delegatedTasks from './delegatedTasks';
import delegationConfigurations from './delegationConfigurations';
import delegations from './delegations';
import DynamicEntity from './dynamicEntity';
import emailMessageTrace from './emailMessageTrace';
import teamsMessageTrace from './teamsMessageTrace';
import smsMessageTrace from './smsMessageTrace';
import emailTemplate from './emailTemplate';
import emailNotificationTemplate from './emailTemplate';
import Environment from './environment';
import FormInstanceData from './formInstanceData';
import InstanceActionType from './instanceActionType';
import ManageAgents from './manageAgents';
import ManageEntities from './manageEntities';
import ManageLists from './manageLists';
import ManageListTaskTrace from './manageListTaskTrace';
import ManageProcess from './manageProcess';
import ManageProcessPortalConfig from './manageProcessPortalConfig';
import ManageReports from './manageReports';
import ProcessPortal from './processPortal';
import ReportGroup from './reportGroup';
import ReportToken from './reportToken';
import ManageSequenceTraces from './manageSequenceTraces';
import ManageSubSequence from './manageSubSequence';
import ManageTokenTrace from './manageTokenTrace';
import NameAndDescription from './nameAndDescription';
import NameDescriptionIsActive from './nameDescriptionIsActive';
import PowerBIServerConfiguration from './powerBIServerConfiguration';
import ProcessGroup from './processGroup';
import ProcessInstanceDetails from './processInstanceDetails';
import Requests from './requests';
import Tasks from './tasks';
import Trace from './trace';
import aiConsumption from './aiConsumption';
import AiBillingBudgetPeriod from './aiBillingBudgetPeriod';
import AiBillingCredit from './aiBillingCredit';
import AiBillingCreditUsage from './aiBillingCreditUsage';
import BillingSubscription from './billingSubscription';
import ChannelAgreement from './channelAgreement';
import ChannelDistributor from './channelDistributor';
import ChannelOperator from './channelOperator';
import ChannelPartner from './channelPartner';
import ChannelReseller from './channelReseller';
import ChannelReferralAgent from './channelReferralAgent';
import ChannelCustomerAssignment from './channelCustomerAssignment';
import ChannelRegistrationApproval from './channelRegistrationApproval';
import ChannelPlan from './channelPlan';
import userGroup from './userGroup';
import UserPosition from './userPosition';
import UserExtraField from './userExtraField';
import UserDevice from './userDevice';
import User from './user';
import ShortenedUrl from './shortenedUrl';
import Sequence from './sequence';
import Media from './media';
import MediaCategory from './mediaCategory';
import AiSkill from './aiSkill';
import AiSkillGroup from './aiSkillGroup';
import AiVector from './aiVector';
import AiAgentTeam from './aiAgentTeam';
import AiAgentSchedule from './aiAgentSchedule';
import AiAgentScheduleTasks from './aiAgentScheduleTasks';
import GlobalUserGroupApproverUser from './globalUserGroupApproverUser';
import GlobalUserGroupApproverByPosition from './globalUserGroupApproverByPosition';
import GlobalUserGroupApproverByArea from './globalUserGroupApproverByArea';
import GlobalEntityApproverUser from './globalEntityApproverUser';
import GlobalEntityApproverByUserGroup from './globalEntityApproverByUserGroup';
import GlobalEntityApproverByPosition from './globalEntityApproverByPosition';
import GlobalEntityApproverByArea from './globalEntityApproverByArea';

/** Namespace to serve DB Queries */
const CoreQueries = (() => {
  return {
    Requests,
    ProcessInstanceDetails,
    FormInstanceData,
    ManageReports,
    ReportGroup,
    ReportToken,
    ManageProcess,
    ProcessPortal,
    ManageAgents,
    ManageLists,
    ManageListTaskTrace,
    UserPosition,
    UserExtraField,
    UserDevice,
    User,
    ManageEntities,
    NameAndDescription,
    AccessLog,
    SecurityEvents,
    SecurityEventDestination,
    NameDescriptionIsActive,
    Trace,
    aiConsumption,
    AiBillingBudgetPeriod,
    AiBillingCredit,
    AiBillingCreditUsage,
    BillingSubscription,
    ChannelAgreement,
    ChannelDistributor,
    ChannelOperator,
    ChannelPartner,
    ChannelReseller,
    ChannelReferralAgent,
    ChannelCustomerAssignment,
    ChannelRegistrationApproval,
    ChannelPlan,
    ProcessGroup,
    PowerBIServerConfiguration,
    Tasks,
    ManageSubSequence,
    ManageSequenceTraces,
    ManageTokenTrace,
    InstanceActionType,
    ManageProcessPortalConfig,
    userGroup,
    connections,
    emailMessageTrace,
    teamsMessageTrace,
    smsMessageTrace,
    emailTemplate,
    emailNotificationTemplate,
    connectionGroup,
    configInternalTasks,
    delegations,
    delegationConfigurations,
    delegatedTasks,
    DynamicEntity,
    Environment,
    ShortenedUrl,
    Sequence,
    Media,
    MediaCategory,
    AiSkill,
    AiSkillGroup,
    AiVector,
    AiAgentTeam,
    AiAgentSchedule,
    aiAgentScheduleTasks: AiAgentScheduleTasks,
    GlobalUserGroupApproverUser,
    GlobalUserGroupApproverByPosition,
    GlobalUserGroupApproverByArea,
    GlobalEntityApproverUser,
    GlobalEntityApproverByUserGroup,
    GlobalEntityApproverByPosition,
    GlobalEntityApproverByArea,
  };
})();

export default CoreQueries;
